import { gsap } from "gsap";
import General from "./general";
import Sliders from "./sliders";
import ServiceList from "./services-list";
import MousePointer from "./mouse-pointer";
import MouseDrag from "./mouse-drag";
import ParallaxImages from "./parallax-image";
import DarkSections from "./dark-sections";

export default class Components {
	constructor() {
		this.Sliders = document.querySelector(".flickity-slideshow") || false;
		this.ServiceList = document.querySelector(".services-wrapper") || false;
		this.MousePointer = document.querySelector(".mouse-follower") || false;
		this.MouseDrag = document.querySelector(".mouse-drag") || false;
		this.ParallaxImages = document.querySelectorAll(".parallax-image") || false;
		this.DarkSections = document.querySelectorAll(".has-dark-bg") || false;
	}

	init() {
		this.general = new General();
		if (this.Sliders) this.Sliders = new Sliders();
		if (this.ServiceList) this.ServiceList = new ServiceList();
		if (this.MousePointer) this.MousePointer = new MousePointer();
		if (this.MouseDrag) this.MouseDrag = new MouseDrag();
		if (this.ParallaxImages) this.ParallaxImages = new ParallaxImages();
		if (this.DarkSections) this.DarkSections = new DarkSections();

		const scrollToContent = document.querySelector(".icon-down-arrow") || false;

		if (scrollToContent) {
			scrollToContent.addEventListener("click", (ev) => {
				document
					.getElementById("page-wrapper")
					.scrollIntoView({ behavior: "smooth" });
			});
		}

		document.querySelectorAll(".spread-love").forEach((loveMe) => {
			loveMe.addEventListener("dblclick", () => {
				gsap.to(loveMe.querySelector(".heart-wrapper"), {
					duration: 0.4,
					opacity: 1,
				});

				setTimeout(() => {
					gsap.to(loveMe.querySelector(".heart-wrapper"), {
						duration: 0.4,
						opacity: 0,
					});
				}, 2000);
			});
		});
	}

	destroy() {
		if (this.Sliders) this.Sliders.destroy();
	}
}
